import ProgressBar from '~components/dumbs/ProgressBar'
import { Outlet } from 'react-router-dom'
import { useStore } from '~hooks'

function ProgressBarWrapper() {
  const { register } = useStore()
  return (
    <>
      <ProgressBar progress={register?.progress} />
      <Outlet />
    </>
  )
}

export default ProgressBarWrapper
